Librarian.Modules.Tabs = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["setUpTabs", "goToTab"],

    options: {
        classPrefix: "modules-tabs-",
        title: null, // A placeholder that will go away if everything works correctly
        tabWidth: null,
        tabHeight: null,
        borderBottom: null,
        className: ''
    },

    tabsEl: null,
    tabs: null,
    contentWrapperEl: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    destroy: function() {
        var elements = [this.tabsEl];
        for (var i = elements.length; i--;) {
            if (elements[i]) {
                $(elements[i]).destroy();
                elements[i] = null;
            }
        }
    },

    load: function() {
        if (!this.wrapperEl)
            return;
        this.parent();

        var wrapperEl = new Element("div", {
            "class": (this.options.classPrefix || '') + "menu-wrapper",
            "styles": {
                "width": this.options.tabWidth,
                "height": this.options.tabHeight,
                "border-bottom": this.options.borderBottom
            }
        }).injectInside(this.containerEl);

        this.tabsEl = new Element("ul", {
            "class": (this.options.classPrefix || '') + "menu tab-menu"
        }).injectInside(wrapperEl);

        this.contentWrapperEl = new Element("div", {
            "class": (this.options.classPrefix || '') + "content"
        }).injectInside(this.containerEl);

        this.tabs = [];
        var tabs = this.options.tabs,
            length = tabs.length,
            newTabs = [];
        // Remove tabs that don't have a name
        for (var i = 0; i < length; i++) {
            if (tabs[i].name)
                newTabs.push(tabs[i]);
        }
        tabs = newTabs;
        length = tabs.length;

        for (var i = 0; i < length; i++) {
            var tabName = tabs[i].name,
                tabPage = tabs[i].page || tabName;

            if (!tabName)
                continue;
            var tab = new Element("li", {
                id: tabName.replace(/,/g, "").replace(/ /g, '')
        });
            new Element('a', {
                    text: tabName
                })
                .injectInside(tab);
            if (this.options.className)
                tab.addClass(this.options.className);
            tab.injectInside(this.tabsEl);
            this.setUpTabs(tabName, tab, tabPage, tabs[i].onTabClicked);
            this.tabs.push(tab);
            if (i == 0) {
                this.tabs[i].addClass("selected");
                this.goToTab(tabName, tabPage);
            }
        }
        MochaUI.initializeTabs(this.tabsEl);
    },

    setUpTabs: function(tabName, tabEl, tabPage, onTabClicked) {
        if (tabEl) {
            var self = this;
            tabEl.addOnClick(function() {
                if (self.currentTab == tabName)
                    return;
                if (onTabClicked)
                    onTabClicked();
                self.currentTab = tabName;
                var modules = Library.getPageModules(tabPage);
                if (!modules)
                    return;
                Librarian.moduleLoader.loadModules(modules, self.contentWrapperEl, "-tabs");
            });
        }
    },

    goToTab: function(tabName, tabPage) {
        if (!tabName || this.currentTab == tabName || !tabPage)
            return;
        var className= '';
        if (this.options.className)
            className = '.' + this.options.className;

        this.containerEl.getElements("li.selected" + className).removeClass("selected");
        this.containerEl.getElement("#" + tabName.replace(/,/g, "").replace(/ /g, '')).addClass("selected");
        this.currentTab = tabName;
        var modules = Library.getPageModules(tabPage);
        if (!modules)
            return;
        Librarian.moduleLoader.loadModules(modules, this.contentWrapperEl, "-tabs");
    }
});